import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchReport } from '@api/report';
import { store } from '@features/redux/store';
import { setLastUpdated } from '@features/redux/slices/reportSlice';

import type { ResponseMap } from '@/types/responses';
import { fetchReportV2 } from '@api/reporting';

export const useReportLoad = <T extends keyof ResponseMap>({
    reportType,
    params,
    v2
}: {
    reportType: T;
    params: { [key: string]: any };
    v2?: boolean;
}): { data: ResponseMap[T][]; hasData: boolean; loading: boolean } => {
    const { IdToken } = useSelector((state: any) => state.auth);

    const [loading, setLoading] = useState<boolean>(false);

    const [data, setData] = useState<ResponseMap[T][]>([]);

    const { startDate, endDate, range, materialId, productName } = params;

    const getReport = async () => {
        setLoading(true);
        const fetchFn = v2 ? fetchReportV2 : fetchReport;
        const resp = await fetchFn(reportType, IdToken, params);
        setData(resp);
        setLoading(false);
        store.dispatch(setLastUpdated());
    };

    useEffect(() => {
        getReport();
    }, [startDate, endDate, range, materialId, productName]);

    return {
        data: (data || []) as ResponseMap[T][],
        hasData: data && data.length > 0,
        loading,
    };
};
